import { ILegalStatus, ILegalType } from "@wot/typings";
import xhr from "../utils/fetch";
export interface ILegal {
  _id: string;
  type: ILegalType;
  text: string;
  createdAt: string;
  status: ILegalStatus;
}

const getDocuments = async (type: ILegalType) => {
  return await xhr({
    url: `/legal?type=${type}`,
    method: "GET",
  }).then((res) => res.data)
    .catch(err => { throw err })
};

const legalApi = {
  getDocuments,
};

export default legalApi;
